import { ANALYTICS_GROUP_TYPES } from "@upsquad/shared";
import posthog from "posthog-js";
import { env } from "@/src/common/constants/env";

if (env.POSTHOG_TOKEN && env.MODE !== "development") {
	posthog.init(env.POSTHOG_TOKEN, {
		api_host: env.POSTHOG_HOST || "https://us.i.posthog.com",
		ui_host: "https://us.posthog.com",
		person_profiles: "identified_only",
		defaults: "2026-01-30",
		capture_pageview: true,
		capture_pageleave: true,
	});
}

export function setActiveCommunityGroup(communityId: string | null): void {
	if (!communityId) return;
	posthog.group(ANALYTICS_GROUP_TYPES.COMMUNITY, communityId);
}

export { posthog };
